<div class="overview-identity" *ngIf="!wizardCtrl.getWizardService().isLoading">
  <div>
    <p class="label">Review</p>
  </div>
  <div class="overview-identity__header">
    <span>Identity</span>
    <div class="edit-properties-btn" (click)="wizardCtrl.editBasicInfo()">
      EDIT
    </div>
  </div>
  <div class="overview-identity__block">
    <div class="overview-identity__row" *ngIf="isCloudBased()">
      <div class="app-logo medium-margin">
        <logo-widget
          [serviceUrl]="step.parent.output.url"
          [styleInfo]="'logo-48-wide'"
          [defaultUrl]="'images/services.svg'"
        ></logo-widget>
      </div>
      <div class="overview-basic__details medium-margin">
        <div>
          <b>{{ step.parent.output.name }}</b>
        </div>
        <div>
          <span>{{ step.parent.output.url }}</span>
        </div>
      </div>
    </div>

    <div class="overview-identity__row" *ngIf="isOnPremise()">
      <div class="app-logo medium-margin">
        <div class="app-logo" >
          <i class="material-icons premise-app-icon mdi mdi-television-guide"></i>
        </div>
      </div>
      <div class="overview-identity__details medium-margin">
        <div>
          {{ step.parent.output.name }}
        </div>
      </div>
    </div>

    <div class="overview-identity__row" *ngIf="isOnPremise()">
      <div class="overview-identity__app-servers medium-margin">
        <div class="bottom-border--light">Host or IP list</div>
        <div class="bottom-border--light">Protocol</div>
        <div class="bottom-border--light">Port(s)</div>
        <ng-container *ngFor="let row of step.parent.output.applicationServers; index as rowIndex">
          <div>{{row.hostName}}{{renderAsOneLine(row.ips)}}
          </div>
          <div>
              {{renderAsOneLine(row.ipProtocols)}}
          </div>
          <div>
            {{renderPortsAsOneLine(row.ports)}}
          </div>
        </ng-container>
      </div>
    </div>

  </div>
</div>
<div *ngIf="wizardCtrl.getWizardService().isLoading" class="flex-centered">
  <div class="label label--bold medium-margin">
    <p>{{loadingMsg}}</p>
  </div>
  <mat-spinner></mat-spinner>
  <div class="label medium-margin">One moment...</div>
</div>
